/**
 * Schema for getOrderHasDriver endpoint
 */

import { z } from "zod";

export const getOrderHasDriverArgsSchema = z.object({
  orderId: z.string(),
  driverId: z.string()
});
